import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthGate } from "./auth/AuthGate";
import { ConnectPage } from "./auth/ConnectPage";
import { LoginPage } from "./auth/LoginPage";
import { SetupPage } from "./auth/SetupPage";
import { Editor } from "./editor/Editor";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Login en de eerste inrichting zijn publiek. */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/setup" element={<SetupPage />} />
        {/* Koppelen via de browser: een app vraagt om namens jou te werken. */}
        <Route
          path="/connect"
          element={
            <AuthGate>
              <ConnectPage />
            </AuthGate>
          }
        />
        {/* Everything else is gated — AuthGate redirects to /login on 401.
            Settings was tot 2026-05-21 op een eigen `/settings`-route;
            sinds de Settings-dropdown-migratie zit alles in modals op
            de hoofd-Editor-pagina. Route + SettingsPage zijn opgeruimd. */}
        <Route
          path="/"
          element={
            <AuthGate>
              <Editor />
            </AuthGate>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
